import { useRouter } from 'vue-router/composables';
import { useAssistantStore } from '@/composition/assistant/use-assistant-store';
import { useAuthStore } from '@/composition/use-auth';
import { useMenuStore } from '@/composition/use-menu';
import { useRestaurantNav } from '@/composition/use-restaurant-nav';
import { i18n } from '@/plugins/i18n';
import { useRestaurantStore } from '@/stores/restaurant.store';
import type { ICartadigitalAdminHostToolDeps } from './tools/tool-types';

/**
 * The stores and app hooks the GPTHelp host reads (tools, context, cards).
 * Call it in a component's setup: the navigation is a computed of that
 * component and the router comes from it.
 */
export function useAdminHostToolDeps(): ICartadigitalAdminHostToolDeps {
  const restaurantStore = useRestaurantStore();
  const authStore = useAuthStore();
  const router = useRouter();
  const nav = useRestaurantNav(() => {
    const restaurant = restaurantStore.restaurant;
    const role = authStore.currentRole;
    return restaurant && role
      ? { restaurant, role, isStaff: !!authStore.user?.admin }
      : null;
  });

  return {
    restaurantStore,
    authStore,
    menuStore: useMenuStore(),
    assistantStore: useAssistantStore(),
    i18n,
    restaurantNav: () => nav.value,
    routePath: () => router.currentRoute.path,
  };
}
